import script from "./TotalsApp.vue?vue&type=script&setup=true&lang=js"
export * from "./TotalsApp.vue?vue&type=script&setup=true&lang=js"

import "./TotalsApp.vue?vue&type=style&index=0&id=49b937a6&lang=css"

const __exports__ = script;

export default __exports__